/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apex Team finds the best possible 5-driver + 2-constructor lineup that fits within your budget each race (everyone starts the season with $100M), ranked by total predicted points.`)
};

const es_f1_apex_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apex Team encuentra la mejor alineación posible de 5 pilotos + 2 constructores que se ajuste a tu presupuesto en cada carrera (todos empiezan la temporada con $100M), ordenada por puntos predichos totales.`)
};

const de_f1_apex_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apex Team findet die bestmögliche Aufstellung aus 5 Fahrern + 2 Konstrukteuren, die in dein Budget pro Rennen passt (jeder startet die Saison mit 100M$), sortiert nach vorhergesagten Gesamtpunkten.`)
};

const nl_f1_apex_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apex Team vindt de best mogelijke opstelling van 5 coureurs + 2 constructeurs die past binnen je budget per race (iedereen start het seizoen met $100M), gerangschikt op totale voorspelde punten.`)
};

const fr_f1_apex_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apex Team trouve la meilleure composition possible de 5 pilotes + 2 constructeurs qui rentre dans votre budget à chaque course (tout le monde commence la saison avec 100M$), classée par points prédits totaux.`)
};

const it_f1_apex_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apex Team trova la migliore formazione possibile di 5 piloti + 2 costruttori che rientra nel tuo budget per ogni gara (tutti iniziano la stagione con 100M$), ordinata per punti previsti totali.`)
};

const pt_br2_f1_apex_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Apex Team encontra a melhor escalação possível de 5 pilotos + 2 construtores que cabe no seu orçamento a cada corrida (todos começam a temporada com $100M), ranqueada por pontos previstos totais.`)
};

const pt_f1_apex_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Apex Team encontra a melhor formação possível de 5 pilotos + 2 construtores que se encaixa no seu orçamento em cada corrida (todos começam a temporada com $100M), ordenada por pontos previstos totais.`)
};

const ja_f1_apex_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apex Teamは、各レースの予算内に収まる最適な5ドライバー＋2コンストラクターの編成を見つけます（シーズン開始時は全員$100M）。予測合計ポイント順にランク付けされます。`)
};

const zh_f1_apex_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apex Team 寻找在你每场比赛的预算内（赛季初始预算为1亿美元）最佳的5位车手+2支车队阵容，按预测总积分排序。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_how_p1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_how_p1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_how_p1", locale)
	if (locale === "en") return en_f1_apex_how_p1(inputs)
	if (locale === "es") return es_f1_apex_how_p1(inputs)
	if (locale === "de") return de_f1_apex_how_p1(inputs)
	if (locale === "nl") return nl_f1_apex_how_p1(inputs)
	if (locale === "fr") return fr_f1_apex_how_p1(inputs)
	if (locale === "it") return it_f1_apex_how_p1(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_how_p1(inputs)
	if (locale === "pt") return pt_f1_apex_how_p1(inputs)
	if (locale === "ja") return ja_f1_apex_how_p1(inputs)
	return zh_f1_apex_how_p1(inputs)
};